import ViewportObserverService from "Services/ViewportObserverService";
import { IN_VP_EVENT, OUT_VP_EVENT } from "Constants/eventNames";

class ZhiContentPageHero extends HTMLElement {

  connectedCallback() {
    ViewportObserverService.observe(this);

    this.addEventListener(IN_VP_EVENT, () => this.handleInViewport());
    this.addEventListener(OUT_VP_EVENT, () => this.handleOutViewport());
  }

  handleInViewport() {
    this.setAttribute("in-viewport", "");
    this.setAttribute("loaded", "");
  }
  
  handleOutViewport() {
    this.removeAttribute("in-viewport")
    this.setAttribute("loaded", "");
  }
}

customElements.define("zhi-content-page-hero", ZhiContentPageHero);